import React, { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { toast } from 'react-toastify';
import api from '../config/api';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { completePendingAction } from '../utils/pendingAction';
import { auth, googleProvider } from '../config/firebase';

const GoogleLoginButton = ({ onSuccess, onError, buttonText = 'Continue with Google', isSignup = false }) => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleGoogleAuth = async () => {
    setLoading(true);
    try {
      // Sign in with Google using Firebase
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      // Extract user information
      const userData = {
        googleId: user.uid,
        email: user.email,
        name: user.displayName || user.email?.split('@')[0] || 'User',
        profileImage: user.photoURL || null,
      };

      // Send to backend - the google-signin endpoint handles both login and signup
      const response = await api.post('/user/auth/google-signin', userData);

      login(response.token, response.user);

      if (onSuccess) {
        onSuccess();
      } else {
        toast.success(isSignup ? 'Account created with Google successfully' : 'Logged in with Google successfully');
        const didComplete = await completePendingAction(navigate);
        if (!didComplete) navigate('/');
      }
    } catch (error) {
      console.error('Google authentication error:', error);
      
      // Handle specific Firebase errors
      if (error.code === 'auth/popup-closed-by-user') {
        // User closed the popup, don't show error
        return;
      } else if (error.code === 'auth/popup-blocked') {
        toast.error('Popup was blocked. Please allow popups for this site.');
      } else if (error.code === 'auth/cancelled-popup-request') {
        // Multiple popups, ignore
        return;
      } else {
        if (onError) {
          onError(error);
        } else {
          toast.error(error.response?.data?.error || 'Google authentication failed');
        }
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      className="google-login-btn"
      onClick={handleGoogleAuth}
      disabled={loading}
    >
      <svg className="google-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      {loading ? 'Processing...' : buttonText}
    </button>
  );
};

export default GoogleLoginButton;

